import React, { useEffect, useState, useRef } from 'react';
import VisitorTable from './visitor_table';
import PageHeaderComponent from '../../../../helpers/components/page_header.component';
import {Button, DatePicker, Divider, Dropdown, Input, List, notification, Radio, Space, Tooltip} from 'antd';
import FilterBullet from '../../../../helpers/components/filter_bullet';
import {CaretDownFilled, DownOutlined, PrinterOutlined, SearchOutlined} from '@ant-design/icons';
import parkService from '../../../../services/config/park.service';
import dayjs from 'dayjs';
import ReactToPrint from 'react-to-print';
import serviceHelper from '../../../../helpers/functions/service.helper';
import moment from "moment/moment";
import globalHelper from "../../../../helpers/functions/global.helper";
import entranceService from "../../../../services/operation/entrance.service";

const VisitorReport = ({ default_filter }) => {
    const { innerWidth } = window;
    const componentRef = useRef();
    const [state, setState] = useState({

    });
    
    const [filter, setFilter] = useState({
        park_id : default_filter?.park_id,
        visit_date : default_filter?.visit_date ? dayjs(default_filter?.visit_date)?.format("YYYY-MM-DD") : dayjs()?.format("YYYY-MM-DD"),
    });

    const fetchFilterItem = async () => {
        const parkResponse = await parkService?.getParkByAuth();
        setState(state => ({...state, parks : parkResponse?.parks}));
    }

    const changeDate = (date) => {
        const visit_date = date ? dayjs(date)?.format("YYYY-MM-DD") : dayjs()?.format("YYYY-MM-DD");
        setFilter(filter => ({...filter, visit_date : visit_date}));

        changeFilter("visit_date", visit_date);
    }

    const onChange = (key, checkedValues) => {
        setFilter(filter => ({...filter, [key] : checkedValues}))
        changeFilter(key, checkedValues);
    }

	const exportNotCheckInReport = async () => {

		const { park_id, visit_date} = filter;

		const visitorReportResponse = await entranceService?.generateNotCheckInReports({
			park_id, visit_date,
		})

		const {  non_checked_in_users } = visitorReportResponse;

		let rows = [];

		if(non_checked_in_users?.length > 0){
			 rows = non_checked_in_users.map((user, index) => {
				const {
					ticket_user_no,
					open_date,
					ticket_user_type,
					ticket,
				} = user ?? {};

				return {
					"No": index + 1,
					"Visit Date": moment(open_date)?.isValid()
						? moment(open_date).format("DD MMM YYYY")
						: "",
					"Ticket User No": ticket_user_no,
					"Ticket Type": ticket_user_type?.name ?? "",
					"Transaction no.": ticket?.unique_no+ticket.salt ?? "",
					"Buyer Name": ticket?.name ?? "",
					"Agents": ticket?.agents ?? "",
					"Email": ticket?.email ?? "",

				};
			});

		}
		if(rows.length>0){
			globalHelper.exportToExcel({
				data : rows,
				name : `non_check_in_report_${moment()?.format("YYYYMMDD")}`,
			});
		}
		else{
			notification?.warning({
				message : 'No Data Found',
				description : 'No date change records found for the selected filters. Please adjust your search criteria and try again.',
			});
		}

	}
    // for changing filter
    const changeFilter = (key, value) => {
        let generate_filter = default_filter;
        generate_filter[key] = value;
        const queryString = serviceHelper?.queryString(generate_filter);
        window.history.replaceState({}, '', `${window.location.pathname}?${queryString}`);
    }

    useEffect(() => {
        fetchFilterItem();
    }, []);

    return (
        <>
            <div className='mobile-padding-12'>
                <div style={{marginBottom: 24, textAlign:'start'}}>
                    <PageHeaderComponent title={'Daily Visitor & Check-In Report'} />
                </div>
                <div className='filter-panel'>
                    <div style={{display:'flex', alignItems:'center', }}>
                        <div style={{textAlign:'start',}}>
                            <Space direction={innerWidth > 768 ? 'horizontal' : 'vertical'}>
                                <FilterBullet
                                popover={
                                    <>
                                        <div>
                                            <Input prefix={<SearchOutlined style={{color :'var(--secondary-text-color)'}}/>} placeholder='Search Parks' />
                                        </div>
                                        <Radio.Group
                                        value={filter?.park_id}
                                        // defaultValue={(state?.parks?.length > 0 && state?.parks[0]?.park_id)}
                                        onChange={(e) => onChange('park_id', e.target.value)}
                                        >
                                            <List
                                            style={{ width:280, }}
                                            dataSource={state?.parks}
                                            renderItem={(item, index) => {
                                                const { park_id, name, } = item ?? {};
                                                return (
                                                    <List.Item style={{width:'100%'}} key={index}>
                                                        <div style={{display:'flex', alignItems:'center', width:'100%'}}>
                                                            <div>
                                                                <span>{name}</span>
                                                            </div>
                                                            <div style={{marginLeft:'auto'}}>
                                                                <Radio
                                                                value={park_id}
                                                                >

                                                                </Radio>
                                                            </div>
                                                        </div>
                                                    </List.Item>
                                                )
                                            }}
                                            />
                                        </Radio.Group>
                                    </>
                                }
                                >
                                    <div>
                                        <Space>
                                            <div>
                                                <span>Park{filter?.park_id && `: ${state?.parks?.find(x => x.park_id === filter?.park_id)?.name}` }</span>
                                            </div>
                                            <div>
                                                <CaretDownFilled style={{color:'#a0aec0'}} />
                                            </div>
                                        </Space>
                                        
                                    </div>
                                </FilterBullet>


                                <FilterBullet
                                popover={
                                    <>
                                        <div>
                                            <DatePicker
                                            allowClear
                                            onChange={(e) => changeDate(e)} format={"YYYY-MM-DD"} 
                                            />
                                        </div>
                                    </>
                                }
                                >
                                    <div>
                                        <Space>
                                            <div>
                                                <span>Date
                                                    <span style={{fontSize:12, fontWeight:500, color:'var(--secondary-text-color)'}}>
                                                        {filter?.visit_date && `: ${filter?.visit_date}`}
                                                    </span>
                                                </span>
                                            </div>
                                            <div>
                                                <CaretDownFilled style={{color:'#a0aec0'}} />
                                            </div>
                                        </Space>
                                        
                                    </div>
                                </FilterBullet>
                            </Space>
                        </div>
                        <div style={{marginLeft:'auto'}}>
							<Space>
								<Tooltip title="Please filter by park and date">
									<Dropdown
										placement="bottomRight"
										overlayStyle={{ borderRadius: 12, minWidth: 200 }}
										trigger={['click']}
										menu={{
											items: [
												{
													key: 1,
													disabled: !(filter?.park_id && filter?.visit_date),
													label: (
														<div>
															<div>
																<span>Export Not Check-In Ticket</span>
															</div>
														</div>
													),
													onClick: async () => {
														exportNotCheckInReport();
													},
												},
											],
										}}
									>
										<Button
											loading={state?.generate_loading}
											icon={<DownOutlined />}
										>
											Export
										</Button>
									</Dropdown>

								</Tooltip>
								<ReactToPrint
									trigger={() => (
										<Button icon={<PrinterOutlined />}>Print</Button>
									)}
									content={() => componentRef.current}
									pageStyle={`@page {
                            margin: 24px;
                        }`}
								/>
							</Space>


                        </div>
                    </div>
                </div>
                <Divider />
                <div ref={componentRef} style={{marginTop:12,}}>
                    <VisitorTable filter={filter} />
                </div>
            </div>
        </>
    );
}

export default VisitorReport;
